import styled from "styled-components"
import breakpoint from "styled-components-breakpoint"
import { Label, FieldGroup } from "../../forms"

export const Container = styled.div`
  > * {
    width: 100%;
    margin-bottom: 0.5rem;
  }

  ${breakpoint("tablet")`
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;

    > * {
      width: unset;
    }

    > :not(:last-child) {
      margin-right: 0.5rem;
    }
  `}
`

export const StyledLabel = styled.label`
  margin: 0;
  font-size: 1rem;
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.body};
  display: flex;
  justify-content: space-between;
`

export const StyledFieldGroup = styled(FieldGroup)`
  gap: 0.5rem;
`
